import React from "react";
import "../assets/style/pages/Home.scss";

const TeamCard = ({ data }) => {
    return (
        <div className="team-card col-lg-2 col-sm-4 col-10">
            <img src={data.image} className="team-card-image" alt="team-member"/>
            <div className="card-body">
                <h5 className="card-title text-center">{data.name}</h5>
                <p className="card-text">
                    {data.text}
                </p>
            </div>
        </div>
    )
}

const elodie = {
    image: "pictures/contactBack.jpg",
    name: "Elodie",
    text: "Aînée de la sororie, elle aura à coeur de répondre aux besoins des chevaux de manière douce et respectueuse. Vous pourrez la croiser tous les jours hors horaires de travail.",
};

const solene = {
    image: "pictures/contactBack.jpg",
    name: "Solène",
    text: "Dynamique et travailleuse, vous pourrez la croiser régulièrement qui saura échanger avec vous.",
};

const chloe = {
    image: "pictures/contactBack.jpg",
    name: "Chloé",
    text: "Cadette de la sororie, vous pourrez la croiser de temps en temps, elle saura répondre à vos questions grâce à son parcours scolaire dans le monde équestre.",
};

const evelyne = {
    image: "pictures/contactBack.jpg",
    name: "Evelyne",
    text: "Responsable de la passion de la famille, elle a su transmettre son amour des chevaux à ses filles jusqu'à vouloir posséder cette pension. Vous pourrez la croiser les lundi et jeudi ainsi que les weekends.",
};

const laurent = {
    image: "pictures/contactBack.jpg",
    name: "Laurent",
    text: "Premier supporter des cavalières, mais également bricoleur en chef, Laurent possède plusieurs casquettes dans cette écurie. Vous pourrez le croiser principalement les jeudis et les weekends.",
};

const tigrou = {
    image: "pictures/contactBack.jpg",
    name: "Tigrou",
    text: "Notre fidèle chasseuse de souris. Avant d’arriver ici, elle était une vraie chatte d'écurie, désormais elle profite pleinement de l’amour qu’on lui donne, sur son petit canapé. Vous pourrez peut-être l’apercevoir lors de ses excursions extérieures.",
};


const Home = () => {
    return (
        <div>
            <div className="fullscreen">
                <img src="pictures/home/home.jpg" className="fullscreen-image" alt="footer-image"/>
                <div className="fullscreen-text-container">
                    <h1 className="page-title primary-text">Le Havre de Priya</h1>
                    <p className="page-subtitle primary-text">Une écurie vouée au bien-être équin et humain</p>
                </div>
            </div>
            <div className="row section">
                <div className="col-md-5 teriary centered-column-container">
                    A venir ! 
                    {/*<img src="pictures/contactBack.jpg" className="presentation-image image" alt="presentation"/>*/}
                </div>
                <div className="col-md-5 offset-md-1 centered-column-container column-top-spacing">
                    <h2 className="section-title">Une écurie pour vous et vos équidés</h2>
                    <p className="section-text">
                        Niché au cœur d’un paysage bucolique, entre forêt et champs, à mi-chemin de Belfort et Mulhouse, le Havre de Priya est né du rêve d’une famille passionnée par le cheval.
                    </p>
                    <p className="section-text">
                        Autrefois terrain d’élevage, le site « Mill Farm » change de propriétaire pour devenir un terrain de pensionnaires propriétaire. Un lieu pensé pour le bonheur des équidés et de leurs cavaliers.
                    </p>
                    <p className="section-text">
                        Forts de notre expérience au sein de différents pensions et clubs équestres, nous avons voulu créer un refuge où chaque cheval se sente pleinement respecté, au rythme de la nature, et où chaque cavalier trouve plaisir, confiance et sérénité.
                    </p>
                    <p className="section-text">
                        Ici, la forêt murmure, les prés offrent l’espace, et les infrastructures ont été aménagées pour le bien-être animal mais aussi pour l’épanouissement des cavaliers.
                    </p>
                </div>
            </div>
            <div className="primary section">
                <h2 className="section-title">Notre histoire et nos valeurs </h2>
                <p className="section-text">
                    lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </p>
            </div>
            <div className="centered-column-container section">
                <h2 className="section-title">Notre équipe </h2>
                <div className="team-cards-container">
                    <div className="card-container">
                        <div className="col-lg-2 d-lg-block d-none"/>
                        <TeamCard data={elodie} />
                        <TeamCard data={solene} />
                        <TeamCard data={chloe} />
                        <div className="col-lg-2 d-lg-block d-none"/>
                        <TeamCard data={evelyne} />
                        <TeamCard data={laurent} />
                        <TeamCard data={tigrou} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;